var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rule-condition-form" },
    [
      _vm.value.length === 0
        ? _c("div", { staticClass: "empty-text" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("CenterForSorting.noRuleConditions")) + " "
            ),
          ])
        : _vm._e(),
      _vm._l(_vm.value, function (condition, index) {
        return _c(
          "div",
          { key: index, staticClass: "condition-row" },
          [
            _c(
              "el-row",
              {
                staticStyle: { width: "100%" },
                attrs: { gutter: 5, type: "flex", align: "middle" },
              },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "min-width": "30px",
                      "text-align": "center",
                    },
                    attrs: { span: 1 },
                  },
                  [
                    _c("span", { staticClass: "row-index" }, [
                      _vm._v(_vm._s(index + 1) + "."),
                    ]),
                  ]
                ),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "condition-item",
                        attrs: {
                          prop: _vm.propPrefix + "." + index + ".conditionType",
                          rules: {
                            required: true,
                            message: _vm.$t("CenterForSorting.pleaseChoose"),
                            trigger: "change",
                          },
                          "label-width": "0",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "CenterForSorting.conditionType"
                              ),
                              size: "small",
                              disabled:
                                _vm.disabled ||
                                (_vm.isUpdateEnabled && condition.isOriginal),
                            },
                            on: {
                              change: function (val) {
                                return _vm.handleConditionTypeChange(val, index)
                              },
                            },
                            model: {
                              value: condition.conditionType,
                              callback: function ($$v) {
                                _vm.$set(condition, "conditionType", $$v)
                              },
                              expression: "condition.conditionType",
                            },
                          },
                          _vm._l(_vm.conditionConfigs, function (config) {
                            return _c("el-option", {
                              key: config.conditionType,
                              attrs: {
                                disabled:
                                  config.conditionType === "DEFAULT" ||
                                  config.conditionType === "MACHINE_FALLBACK",
                                label: _vm.$t(
                                  "CenterForSorting." + config.conditionType
                                ),
                                value: config.conditionType,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "condition-item",
                        attrs: {
                          prop: _vm.propPrefix + "." + index + ".operator",
                          rules: {
                            required: true,
                            message: _vm.$t("CenterForSorting.pleaseChoose"),
                            trigger: "change",
                          },
                          "label-width": "0",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("CenterForSorting.operator"),
                              size: "small",
                              disabled:
                                _vm.disabled ||
                                (_vm.isUpdateEnabled && condition.isOriginal),
                            },
                            on: {
                              change: function (val) {
                                return _vm.handleOperatorChange(val, index)
                              },
                            },
                            model: {
                              value: condition.operator,
                              callback: function ($$v) {
                                _vm.$set(condition, "operator", $$v)
                              },
                              expression: "condition.operator",
                            },
                          },
                          _vm._l(
                            _vm.getOperators(condition.conditionType),
                            function (op) {
                              return _c("el-option", {
                                key: op,
                                attrs: {
                                  label: _vm.$t("CenterForSorting." + op),
                                  value: op,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 13 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "condition-item",
                        attrs: {
                          prop:
                            _vm.propPrefix + "." + index + ".conditionValue",
                          rules: {
                            required: true,
                            message: _vm.$t("CenterForSorting.notNull"),
                            trigger: ["blur", "change"],
                          },
                          "label-width": "0",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "100%" } },
                          [
                            _vm.getValueType(condition.conditionType) ===
                            "ZipRange"
                              ? [
                                  _c("zip-range", {
                                    attrs: {
                                      disabled:
                                        _vm.disabled ||
                                        (_vm.isUpdateEnabled &&
                                          condition.isOriginal),
                                    },
                                    model: {
                                      value: condition.conditionValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          condition,
                                          "conditionValue",
                                          $$v
                                        )
                                      },
                                      expression: "condition.conditionValue",
                                    },
                                  }),
                                ]
                              : _vm.getValueType(condition.conditionType) ===
                                "Radio"
                              ? [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        size: "small",
                                        disabled:
                                          _vm.disabled ||
                                          (_vm.isUpdateEnabled &&
                                            condition.isOriginal),
                                      },
                                      model: {
                                        value: condition.conditionValue,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            condition,
                                            "conditionValue",
                                            $$v
                                          )
                                        },
                                        expression: "condition.conditionValue",
                                      },
                                    },
                                    _vm._l(
                                      _vm.getAllowedValues(
                                        condition.conditionType
                                      ),
                                      function (opt) {
                                        return _c(
                                          "el-radio",
                                          {
                                            key: opt.value,
                                            attrs: {
                                              label: String(opt.value),
                                              disabled: opt.disabled,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(opt.label) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              : _vm.isWeightCondition(condition)
                              ? [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.disabled ||
                                        (_vm.isUpdateEnabled &&
                                          condition.isOriginal),
                                      placeholder: _vm.$t(
                                        "CenterForSorting.conditionValue"
                                      ),
                                      size: "small",
                                    },
                                    on: {
                                      input: function (val) {
                                        return _vm.handleWeightInput(
                                          val,
                                          condition
                                        )
                                      },
                                    },
                                    model: {
                                      value: condition.conditionValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          condition,
                                          "conditionValue",
                                          $$v
                                        )
                                      },
                                      expression: "condition.conditionValue",
                                    },
                                  }),
                                ]
                              : _vm.getValueType(condition.conditionType) ===
                                "InputNumber"
                              ? [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      size: "small",
                                      disabled:
                                        _vm.disabled ||
                                        (_vm.isUpdateEnabled &&
                                          condition.isOriginal),
                                    },
                                    model: {
                                      value: condition.conditionValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          condition,
                                          "conditionValue",
                                          $$v
                                        )
                                      },
                                      expression: "condition.conditionValue",
                                    },
                                  }),
                                ]
                              : _vm.getValueType(condition.conditionType) ===
                                "Select"
                              ? [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.getConditionValue(condition),
                                        placeholder: _vm.$t(
                                          "CenterForSorting.conditionValue"
                                        ),
                                        filterable: "",
                                        multiple: _vm.isMultiple(condition),
                                        "collapse-tags": "",
                                        size: "small",
                                        disabled:
                                          _vm.disabled ||
                                          (_vm.isUpdateEnabled &&
                                            condition.isOriginal),
                                      },
                                      on: {
                                        change: function (val) {
                                          return _vm.setConditionValue(
                                            val,
                                            condition
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.getAllowedValues(
                                        condition.conditionType
                                      ),
                                      function (opt) {
                                        return _c("el-option", {
                                          key: opt.value,
                                          attrs: {
                                            label: opt.label,
                                            value: String(opt.value),
                                            disabled: opt.disabled,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              : [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "CenterForSorting.conditionValue"
                                      ),
                                      size: "small",
                                      disabled:
                                        _vm.disabled ||
                                        (_vm.isUpdateEnabled &&
                                          condition.isOriginal),
                                    },
                                    model: {
                                      value: condition.conditionValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          condition,
                                          "conditionValue",
                                          $$v
                                        )
                                      },
                                      expression: "condition.conditionValue",
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 1 },
                  },
                  [
                    _c("el-button", {
                      staticStyle: { "margin-bottom": "18px" },
                      attrs: {
                        type: "danger",
                        icon: "el-icon-minus",
                        circle: "",
                        size: "mini",
                        disabled:
                          _vm.disabled ||
                          (_vm.isUpdateEnabled && condition.isOriginal),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeCondition(index)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "div",
        { staticClass: "add-btn-wrapper" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                plain: "",
                icon: "el-icon-plus",
                size: "small",
                disabled: _vm.disabled,
              },
              on: { click: _vm.addCondition },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("CenterForSorting.addCondition")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }